import { Translate } from "../../../constant/Translate"
import { RequiredFieldType } from "./models"

const { MESSAGE_E0001 } = Translate

export const validatorRequiredField = (): RequiredFieldType => ({
  message: MESSAGE_E0001,
  required: true,
})
